import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { CampaignTable } from '../../common/campaign/CampaignTable'
import { Campaign } from '../../common/types/campaigns'
import RestrictedView from '../auth/RestrictedView'
import { i18n } from '../index/index'
import { Widget } from '../OldDashboard/OldDashboardComponents'

interface Props {
  campaigns: Campaign[]
  stationId: string
}

/**
 * Dashboard campaigns widget. Mirrors the old dashboard campaigns block but adds a
 * manager-only ("Hallitse kampanjoita") button inline with the heading, linking to the
 * station's admin campaigns page where visibility can be toggled.
 */
export default function Campaigns({ campaigns, stationId }: Props) {
  return (
    <Widget>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
        rowGap={1}
        columnGap={1}
        sx={{ mb: 1 }}
      >
        <Typography variant='h5'>{i18n.t('campaigns.heading')}</Typography>
        <RestrictedView requiredPermission='manage_ownStation'>
          <Button
            component={Link}
            to={`/yllapito/toimipaikat/kampanjat/${stationId}`}
            variant='contained'
            color='success'
            size='small'
          >
            {i18n.t('campaigns.manageCampaigns')}
          </Button>
        </RestrictedView>
      </Stack>
      <CampaignTable campaigns={campaigns} />
    </Widget>
  )
}
